<div style="display: flex;flex-direction: row;font-family: Roboto; align-content: space-between; " mat-ripple>
  @if (this.Player[0]) {
    <div style="font-size: 16px; margin-right: 5px;;">
      {{this.Player[0].JerseyNo}}
    </div>
  }
  @if (this.Player[0]) {
    <div (click)="navigate(this.Player[0].PlayerId)">
      <span style="font-size: 12px;">{{this.Player[0].PlayerLastName}}</span>
      <br/>
      <!-- <span style="font-size: 10px">{{this.Player[0].PlayerFirstName}}</span><br/> -->
      <!-- add tags-->
    </div>
  }

</div>